import { type Reply, type UploadedFile, createReplyData } from 'models';
import { useMutation } from 'query';
import { createComment } from '../../services';
import { useAddComment } from '../hooks';

export const useCreateCommentMutation = () => {
  const addComment = useAddComment();

  return useMutation<
    Reply,
    {
      attachments?: UploadedFile[];
      contentObjectId: string;
      htmlContent?: string;
      parentId: string;
      textContent?: string;
    }
  >({
    async mutationFn({ attachments, htmlContent, parentId, textContent }) {
      const response = await createComment({
        /* eslint-disable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
        content_object: {
          attachments: attachments?.map((attachment) => ({
            id: attachment.id,
          })),
          html_content: htmlContent,
          parent_id: parentId,
          text_content: textContent,
        },
        /* eslint-enable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
      });

      return createReplyData(response.data);
    },
    onSuccess(comment, { contentObjectId }) {
      addComment({ contentObjectId, reply: comment });
    },
  });
};
